const optionalString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined;

const optionalBaseUrl = (value: unknown): string | undefined =>
  optionalString(value)?.replace(/\/+$/, '');

/** Canonical site origin for SEO (canonical, Open Graph, sitemap, robots). */
export const SITE_URL =
  optionalBaseUrl(process.env.NEXT_PUBLIC_SITE_URL) ?? 'https://nexhiro.ai';

export const env = {
  NEXT_PUBLIC_APP_URL: optionalString(process.env.NEXT_PUBLIC_APP_URL),
  /** NexHiro API, used by the job board forms in the browser. */
  NEXT_PUBLIC_API_URL: optionalBaseUrl(process.env.NEXT_PUBLIC_API_URL),
  /** Cloudflare Turnstile public key for the apply form. */
  NEXT_PUBLIC_TURNSTILE_SITE_KEY: optionalString(
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY
  ),
  NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN:
    optionalString(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN) ??
    'secret-token',
  NEXT_PUBLIC_POSTHOG_HOST:
    optionalString(process.env.NEXT_PUBLIC_POSTHOG_HOST) ??
    'https://us.i.posthog.com',
  NEXT_PUBLIC_CONTACT_EMAIL:
    optionalString(process.env.NEXT_PUBLIC_CONTACT_EMAIL) ?? 'hello@nexhiro.ai',
  /** Calendly booking page for the Book Demo embed. */
  NEXT_PUBLIC_CALENDLY_URL:
    optionalString(process.env.NEXT_PUBLIC_CALENDLY_URL) ??
    'https://calendly.com/wael-aldahmashi/15min',
  /** Grafana Cloud Faro collector URL (per-app, e.g. https://faro-collector-prod-eu-west-2.grafana.net/collect/<key>) */
  NEXT_PUBLIC_FARO_URL: optionalString(process.env.NEXT_PUBLIC_FARO_URL),
  NEXT_PUBLIC_FARO_APP_NAME: optionalString(
    process.env.NEXT_PUBLIC_FARO_APP_NAME
  ),
  NEXT_PUBLIC_FARO_APP_ENV: optionalString(
    process.env.NEXT_PUBLIC_FARO_APP_ENV
  ),
  NEXT_PUBLIC_APP_VERSION: optionalString(process.env.NEXT_PUBLIC_APP_VERSION),
  /** GA4 measurement ID (e.g. G-XXXXXXXXXX). When unset, Google tag scripts are not loaded. */
  NEXT_PUBLIC_GOOGLE_TAG_ID: optionalString(
    process.env.NEXT_PUBLIC_GOOGLE_TAG_ID
  ),
  /** Google Tag Manager container ID (e.g. GTM-XXXXXXX). When unset, GTM script is not loaded. */
  NEXT_PUBLIC_GTM_ID: optionalString(process.env.NEXT_PUBLIC_GTM_ID),
} as const;
